export default {
  namespaced: true,
  state: {
    processoSelecionado: null,
    datasRemocao: [],
    servidorSolicitante: null,
    inscriscaousuario: null,
    listauploadsInscricao: [],
  },
  getters: {
    getListaUploadsInscricao(state) {
      return state.listauploadsInscricao;
    },
    processoSelecionado(state) {
      return state.processoSelecionado;
    },
    datasRemocao(state) {
      return state.datasRemocao;
    },
    getServidorSolicitante(state) {
      return state.servidorSolicitante;
    },
    getInscricaoUsuario(state) {
      return state.inscriscaousuario;
    },
  },
  mutations: {
    setListaUploadsInscricao(state, payload) {
      state.listauploadsInscricao = payload;
    },
    setProcessoSelecionado(state, payload) {
      state.processoSelecionado = payload;
    },
    setDatasRemocao(state, payload) {
      state.datasRemocao = payload;
    },
    setServidorSolicitante(state, payload) {
      state.servidorSolicitante = payload;
    },
    setInscricaoUsuario(state, payload) {
      state.inscriscaousuario = payload;
    },
  },
  actions: {},
};
